import * as model from './model.js';
import modalView from './Views/modalView.js';
import heroView from './Views/heroView.js';

// Function to clone the data, added here because model is automatically generated
const cloneData = function (data) {
  return JSON.parse(JSON.stringify(data));
};

const getNodeSlugFromURL = () => {
  const params = new URLSearchParams(window.location.search);
  const slug = params.get('node');
  return slug ? decodeURIComponent(slug) : null;
};

const init = function () {
  const nodeSlug = getNodeSlugFromURL();
  heroView.renderView(cloneData(model.data));
  heroView.addHandlerRecenterGraph(() => cloneData(model.data));
  heroView.addHandlerResizeViewport(() => cloneData(model.data));
  // modalView.addHandlerRenderModal(cloneData(model.data));
  // modalView.addHandlerCloseModal(() => cloneData(model.data));

  if (nodeSlug) heroView.highlightNodeBySlug(nodeSlug);
};
init();
